














































































































































import { Button } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import PassengersPaymentTab from '@/components/modals/PassengersPaymentTab.vue'

import Passenger from '@/models/passenger'
import Recipient from '@/models/recipient'
import { VisaLetterData } from '@/models/visa-letter-data'
import VisaLetterModalSteps from '@/models/visa-letter-modal-steps'

import dayjs, { Dayjs } from '@/dayjs'

@Component({
  components: {
    [Button.name]: Button,
    PassengersTab: PassengersPaymentTab,
  },
})
export default class SailCroatiaBody extends Vue {
  @Prop() passengers!: Passenger[]
  @Prop() recipients!: { [id: number]: Recipient }
  @Prop() visaLetterData!: VisaLetterData
  @Prop() visaLetterIsReady!: boolean
  @Prop(String) currentStep!: VisaLetterModalSteps
  @Ref() readonly visaLetterPrintable!: HTMLElement

  get steps() {
    return VisaLetterModalSteps
  }

  get recipientPassengers(): Passenger[] {
    return this.passengers.filter(
      (passenger) =>
        this.recipients[passenger.id] && this.recipients[passenger.id].isChosen,
    )
  }

  get departure(): Dayjs {
    return dayjs.utc(this.visaLetterData.departure)
  }

  get finishDate(): Dayjs {
    return dayjs.utc(this.visaLetterData.finishDate)
  }
}
